import { CompanyDto } from './companyDto'
import { ImportBranchDto } from './importBranchDto'
import { PersonDto } from './personDto'

export class VehicleDamageDto {
  vehicleDamageGuid?: string = undefined
  vehicleGuid?: string = undefined
  vehicleId?: string = undefined
  vehicleDamageId?: string = undefined
  vin?: string = undefined
  make?: string = undefined
  model?: string = undefined
  year?: string = undefined
  importerStockNumber?: string = undefined
  initialDamageDate?: string = undefined
  damageDescription?: string = undefined
  damageStatus?: string = undefined
  damagePhoto1FileName?: string = undefined
  damagePhoto1File?: File = undefined
  damagePhoto2FileName?: string = undefined
  damagePhoto2File?: File = undefined
  damagePhoto3FileName?: string = undefined
  damagePhoto3File?: File = undefined
  exporterCompany?: CompanyDto = undefined
  buyerCompany?: CompanyDto = undefined
  importBranch?: ImportBranchDto = undefined
  createdDateTime?: string = undefined
  createdBy?: PersonDto = undefined
  updatedDateTime?: string = undefined
  updatedBy?: PersonDto = undefined
}
